import { render, staticRenderFns } from "./change-print-type.vue?vue&type=template&id=2da997f4&scoped=true"
import script from "./change-print-type.vue?vue&type=script&lang=js"
export * from "./change-print-type.vue?vue&type=script&lang=js"
import style0 from "./change-print-type.vue?vue&type=style&index=0&id=2da997f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da997f4",
  null
  
)

export default component.exports